/* eslint-disable  */
import React, { Component } from 'react';
import { Collapse } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toast } from 'react-toastify';
import { hangupCall, startRecording, stopRecording } from '../actions/call';
import { callTimer, toastErrorMsg } from '../utils/utils';
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";
import "../agent/Styles/highContrast.css";
import { TbPhoneOutgoing, TbPhoneIncoming, TbHeadset } from  "react-icons/tb";
import { ImTree } from  "react-icons/im";

let panelHeight = 0;
class Runtime extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: true,
			recording: false,
			processingHangUp: false
		};
	}
	componentWillMount = () => {	
		const id = this.props.onGoingCalls[0].data.id;
		this.setState({
			[`recording${id}`]: false,
			[`timer${id}`]: '00:00',
		}, () => {
			// this.showTimer(id);
			this.getPanelHeight();
		});
	}

	componentDidUpdate = () => {
		this.getPanelHeight();
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.terminatedCall.data.id !== this.props.terminatedCall.data.id) {
			// this.getPanelHeight();
			clearInterval(this[`timer${nextProps.terminatedCall.data.id}`]);
		}
		// if(nextProps.onGoingCalls.length > this.props.onGoingCalls.length){
		// 	const lastId = nextProps.onGoingCalls[nextProps.onGoingCalls.length - 1].data.id;
		// 	this.setState({
		// 		[`recording${lastId}`]: false,
		// 		[`timer${lastId}`]: '00:00',
		// 	}, () => {
		// 		this.showTimer(lastId);
		// 	})
		// 	// this.getPanelHeight();
		// }
		if (nextProps.answeredCall !== this.props.answeredCall) {
			this.setState({
				[`recording${nextProps.answeredCall}`]: false,
				[`timer${nextProps.answeredCall}`]: '00:00',
			}, () => {
				this.showTimer(nextProps.answeredCall);
			})
		}
	}

	componentWillUnmount = () => {
		const id = this.props.onGoingCalls[0].data.id
		clearInterval(this[`timer${id}`]);
		panelHeight = 0;
		document.getElementById('sidebar').style.marginTop = '-20px';
		document.getElementById('sidebar').style.paddingTop = '20px';
		document.getElementById('sidebar').style.height = 'calc(100vh - 45px)';
	}

	getPanelHeight = () => {
		const height = document.getElementById('runtimeWrapper').clientHeight;
		if (panelHeight != height) {
			panelHeight = height;
			const heightDiff = panelHeight + 100;
			document.getElementById('sidebar').style.marginTop = `calc(${panelHeight}px + 20px)`;
			document.getElementById('sidebar').style.paddingTop = '0px';
			document.getElementById('sidebar').style.height = `calc(100vh - ${heightDiff}px)`;
		}
	}

	close = (key) => {
		this.setState({ [key]: false });
	}

	open = (key) => {
		this.setState({ [key]: true });
	}

	handleCallRecord = (e) => {
		if (this.state[`recording${e.target.id}`]) {
			this.handleStopRecording(e.target.id);
		} else {
			this.handleStartRecording(e.target.id);
		}
	}

	handleCallHangup = (e) => {
		if(!this.state.processingHangUp){
			this.setState({ processingHangUp: true });
			this.props.hangupCall(e.target.id).then((res) => {
				this.setState({ processingHangUp: false });
				if (!res.data.result) {
					this.handleError();
				}
			}, (err) => {
				this.handleError();
			})
		}
	}

	handleStartRecording = (callId) => {
		this.props.startRecording(callId).then((res) => {
			if (res.data.result) {
				this.setState({
					[`recording${callId}`]: true
				})
			} else {
				this.handleError();
			}
		}, (err) => {
			this.handleError();
		})
	}

	handleStopRecording = (callId) => {
		this.props.stopRecording(callId).then((res) => {
			if (res.data.result) {
				this.setState({
					[`recording${callId}`]: false
				})
			} else {
				this.handleError();
			}
		}, (err) => {
			this.handleError();
		})
	}

	handleError = () => {
		toastErrorMsg(this.props.translations.commonErrorText[this.props.selectedLanguage], this, "commonErrToast");
	}

	showTimer = (id) => {
		if (!this[`timer${id}`]) {
			let sec = 0;
			this[`timer${id}`] = setInterval(() => {
				sec = sec + 1;
				this.setState({
					[`timer${id}`]: callTimer(sec)
				});
			}, 1000);
		}
	}

	renderList = () => {
		const { onGoingCalls, selectedLanguage, translations } = this.props;

		return (
			onGoingCalls.map(item => {
				return (
					<tr key={item.data.id}>
						<td style={{ width: '70%', fontSize: 13}} className="">
						<span> {item.tag.includes('outgoing') ? <TbPhoneOutgoing/> : <TbPhoneIncoming/>} </span>
							{!item.data.isAnswered && <span style={{ fontSize: 14.5 }}>{translations.ringing[selectedLanguage]}</span>}
							{item.data.isAnswered && <span style={{ fontSize: 14.5 }}>{this.state[`timer${item.data.id}`]} </span>}
							<span style={{ fontSize: 14.5 }}> - {item.tag.includes('outgoing') ? item.data.to : item.data.from}</span>
							{item.data.application_name && <div><ImTree/>{item.data.application_name}</div>}
							<div><TbHeadset/>{item.data.service_name}</div>
						</td>
						
						<td className="text-right">
							{item.data.isAnswered && this.props.permissions.hasRecordingCall === 1 && <a
								title={translations[this.state[`recording${item.data.id}`] ? 'stopRecord' : 'startRecord'][selectedLanguage]}
								id={item.data.id}
								onClick={this.handleCallRecord}
								className={`btn btn-link btn-link${this.props.theme} btn-lg user-status user-unavailable btn-icon`}
								style={{ position: 'relative', height: 30, top: -5 }}
							>
								<span
									id={item.data.id}
									className={`${this.state[`recording${item.data.id}`] ? 'stopBtn' : 'recordBtn'}`}>
									{`${this.state[`recording${item.data.id}`] ? 'STOP' : 'REC'}`}
								</span>
								<span
									id={item.data.id}
									style={{ fontSize: 30 }}
									className={`icon ${this.state[`recording${item.data.id}`] ? 'icon-controller-stop' : 'icon-controller-record'}`}
								/>
							</a>}
							{item.data.isAnswered && <a
								title={translations.hangupCall[selectedLanguage]}
								id={item.data.id}
								onClick={this.handleCallHangup}
								className={`btn btn-link btn-link${this.props.theme} btn-lg user-status user-unavailable btn-icon`}
							>
								<span
									id={item.data.id}
									style={{ fontSize: 22 }}
									className={this.state.processingHangUp ? "fa fa-spinner fa-spin" : "icon icon-phone hangup"}
								/>
							</a>}
						</td>
					</tr>
				);
			})
		);
	}

	render() {
		const { timer } = this.state;
		const { translations, selectedLanguage } = this.props;

		return (
			<div className={`panel${this.props.theme} panel-default${this.props.theme}`} id="runtimeWrapper">
				<div className={`panel-heading panel-heading${this.props.theme}`}>
					<h3 className="panel-title">
						<a className="show">
							<span className="icon icon-phone icon-right-space" />
							{translations.runTime[selectedLanguage]}
						</a>
					</h3>
				</div>
				<Collapse in={this.state.open}>
					<div>
						<div className="table-responsive">
							<table className={`table-fixed table table${this.props.theme} table-condensed table-hover${this.props.theme} small m-a-0`}>
								<tbody style={{ maxHeight: '310px', overflow: 'auto' }}>
									{this.renderList()}
								</tbody>
							</table>
						</div>
						{/* <span className="icon icon-controller-record" />
			<span className="icon icon-phone hangup" /> */}
					</div>
				</Collapse>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		onGoingCalls: state.runtime.onGoingCalls,
		answeredCall: state.runtime.answeredCall,
		terminatedCall: state.runtime.terminatedCall,
		translations: state.languages.translations,
		selectedLanguage: state.languages.selectedLanguage,
		darkMode: state.common.darkMode,
		theme: state.common.theme,
		permissions: state.agentsAndSupervisors.agentPermissions,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		hangupCall,
		startRecording,
		stopRecording
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Runtime);



// WEBPACK FOOTER //
// ./src/agent/Runtime.js